import { FC } from 'react';
import classNames from 'classnames';
import IconDS22 from 'src/common/components/IconDS22';
import styles from './ToggleButton.module.scss';
import getClassNames from '../../utils/getClassNames';

export type ToggleButtonProps = {
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
  classNameModifier?: string;
  disabled?: boolean;
};

const ToggleButton: FC<ToggleButtonProps> = ({
  children, isOpen, onClick, classNameModifier, disabled,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={getClassNames(
      styles,
      'root',
      classNames(classNameModifier, {
        open: isOpen,
      }),
    )}
    disabled={disabled}
  >
    {children}
    <IconDS22
      id="caret-down"
      size="s"
      className={getClassNames(
        styles,
        'icon',
        classNames({ open: isOpen }),
      )}
    />
  </button>
);

export default ToggleButton;
